export const categories = [
  {
    id: "film-tv",
    name: "影视热剧",
    icon: "ri-film-line",
    desc: "剧集、电影的口碑与看点整理",
    count: 246,
  },
  {
    id: "music-live",
    name: "音乐现场",
    icon: "ri-mic-line",
    desc: "巡演、舞台与回归现场合集",
    count: 187,
  },
  {
    id: "variety",
    name: "综艺名场面",
    icon: "ri-emotion-laugh-line",
    desc: "整季综艺的高光片段目录",
    count: 153,
  },
  {
    id: "trending",
    name: "网络热议",
    icon: "ri-fire-line",
    desc: "热梗、话题与讨论脉络",
    count: 402,
  },
  {
    id: "sports",
    name: "体育赛场",
    icon: "ri-basketball-line",
    desc: "关键回合与赛后复盘",
    count: 131,
  },
  {
    id: "life",
    name: "生活趣闻",
    icon: "ri-leaf-line",
    desc: "普通人的高光与烟火日常",
    count: 167,
  },
];